<template>
  <div id="MyAssociation">
    <ul id="associationMemberList" v-if="memberList.length>0">
      <li v-for="item in memberList" v-bind:key="item.AssociationID" @click="goAssociationMemberFunc(item.AssociationID)">
        <div v-if="item.IsEnable" class="content">
          <div class="association-member-list-top">
            <div>
              <div class="association-member-list-title" v-cloak><span class="title">{{item.AssociationName}}</span></div>
              <div class=" association-member-list-count" v-cloak>社长：{{item.FullName}}</div>
            </div>
            <div class="association-member-list-number" v-cloak>{{item.MemberCount}}<span>人</span></div>
          </div>
          <div class="word-wrap association-member-list-textarea" v-bind:title="item.Description" v-cloak>
            {{item.Description}}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Notify } from "vant"
export default {
  name: "MyAssociation",
  data () {
    return {
      loading: false,//保存中状态
      memberList: []
    };
  },
  computed: {
    apiPath () {
      return this.$store.state.apiPath
    }
  },
  created: function () {
    this.getMemberPage()
  },
  methods: {
    getMemberPage () {
      this.xy.loading()
      let that = this
      this.xyapi.get(`${this.apiPath}/api/MyAssociation/GetList`).then(res => {
        if (res.success) {
          if (res.data.length > 0) {
            that.memberList = res.data
          } else {
            that.memberList = []
          }
        } else {
          Notify({ type: "danger", message: res.msg })
        }
        this.xy.unloading()
      })
    },
    goAssociationMemberFunc (AssociationID) {
      this.$router.push({ path: '/home/MyAssociationList', query: { 'AssociationID': AssociationID } })
    }
  }
}
</script>
<style lang='less' scoped>
#MyAssociation {
  background-color: #fff;
  padding-bottom: 10px;
  #associationMemberList {
    width: 80%;
    margin: 0px auto;
    padding-top: 30px;
    li {
      width: 100%;
      margin-bottom: 30px;
      .content {
        .association-member-list-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 20px;
          color: #fff;
          font-size: 32px;
          border-radius: 12px 12px 0px 0px;
          background: #83a4fc;
          background-image: linear-gradient(180deg, #76aefc 0%, #83a4fc 100%);
          .title {
            font-size: 32px;
            font-weight: 600;
          }
          .association-member-list-count {
            display: inline-block;
            margin-top: 20px;
          }
        }
        .association-member-list-number {
          font-size: 60px;
          font-weight: 700;
          span {
            font-size: 28px;
            font-weight: normal;
          }
        }
        .association-member-list-textarea {
          padding: 10px;
          width: 100%;
          height: 150px;
          word-wrap: break-word;
          overflow-y: auto;
          font-size: 28px;
          border-width: 1px;
          border-color: #e4e4e4;
          border-style: solid;
          border-radius: 0px 0px 12px 12px;
          background-color: #f9f9f9;
        }
      }
    }
  }
}
</style>